import React from "react"
import { motion } from "framer-motion"

const Section1: React.FC = () => {
  return (
    <div
      className="w-screen h-screen bg-center bg-cover bg-no-repeat relative"
      style={{ backgroundImage: "url('/home-bg.png')" }}
    >
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-4 py-20">
        <div className="absolute inset-0 pointer-events-none">
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 0.3, scale: 1 }}
            transition={{ duration: 1, delay: 1 }}
            className="absolute top-10 right-10 w-16 h-16 bg-white/20 rounded-full"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 0.2, scale: 1 }}
            transition={{ duration: 1, delay: 1.2 }}
            className="absolute bottom-20 left-10 w-12 h-12 bg-white/20 rounded-full"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 0.25, scale: 1 }}
            transition={{ duration: 1, delay: 1.4 }}
            className="absolute top-1/2 left-5 w-8 h-8 bg-white/20 rounded-full"
          />
        </div>
      </div>

      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
        className="absolute bottom-0 left-0 right-0 z-20 bg-black/20 backdrop-blur-sm text-white p-4"
        style={{ willChange: "transform, opacity" }}
      >
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-sm md:text-base font-medium">
            Sản phẩm phân phối bởi
          </p>
          <p className="text-lg md:text-xl font-bold">
            CTY CP SX TM DV Hương TRÀ CÀ PHÊ
          </p>
          <p className="text-sm md:text-base">
            Địa chỉ: 148 Bình Lợi, P.Bình Lợi Trung, TP. Hồ Chí Minh
          </p>
          <p className="text-sm md:text-base">Điện thoại: 0913173838</p>
        </div>
      </motion.div>
    </div>
  )
}

export default Section1
